import React from 'react'
import PhoneIcon from '@material-ui/icons/Phone'
import FlexView from 'react-flexview/lib'
import { SkywatchThemeContext } from '../../../theme/Theme'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../../services/FirebaseService'
import { useMediaQuery, Tooltip } from '@material-ui/core'

var classNames = require('classnames')

export const SupportPhoneCall = ({ className }) => {
  const themeContext = React.useContext(SkywatchThemeContext)
  const isMobileByWidth = !useMediaQuery((theme) => theme.breakpoints.up('md'))

  const openDialPhone = () =>
    window.open(
      `tel:${FirebaseService.getValue(
        FirebaseConfigKey.SUPPORT_PHONE_NUMBER
      ).replace('-', '')}`,
      '_blank'
    )

  return (
    <FlexView className={className} vAlignContent={'center'}>
      <Tooltip
        placement="bottom"
        title={
          'Tap to call - ' +
          FirebaseService.getValue(FirebaseConfigKey.SUPPORT_PHONE_NUMBER)
        }>
        <PhoneIcon
          onClick={openDialPhone}
          className={classNames(
            'clickable margin-right-3',
            { white: Boolean(themeContext.useColoredBackground) },
            { blue: !Boolean(themeContext.useColoredBackground) }
          )}
        />
      </Tooltip>
      {!isMobileByWidth && (
        <div
          className={classNames(
            'text-body',
            { white: Boolean(themeContext.useColoredBackground) },
            { blue: !Boolean(themeContext.useColoredBackground) }
          )}>
          {FirebaseService.getValue(FirebaseConfigKey.SUPPORT_PHONE_NUMBER)}
        </div>
      )}
    </FlexView>
  )
}
